import { useMemo, useState } from 'react';

import { useEmailRecipients } from '../../api/getEmailRecipients';

const mapEmailRecipient = (response) => {
  return {
    avatar: response.avatar,
    value: response['email-address'],
    label: response.name || response['email-address'],
    valid: response.bounce !== true,
    bounce: response.bounce,
  };
};
export const useFilteredEmailRecipients = ({ projectId }) => {
  const [filter, setFilters] = useState({
    withNonMembers: 0,
    name: '',
  });
  const getRecipientsMutation = useEmailRecipients({
    projectId,
  });

  const filteredRecipientOptions = useMemo(() => {
    if (!getRecipientsMutation.data) {
      return [];
    }

    return getRecipientsMutation.data.data
      .filter((r) => {
        let filterName = null;

        if (filter.name) {
          filterName =
            r.name.toLowerCase().includes(filter.name.toLowerCase()) ||
            r['email-address'].toLowerCase().includes(filter.name.toLowerCase());
        }

        if (filter.withNonMembers) {
          return r && filterName;
        }

        // Return only members
        return filterName ? !!r.name && filterName : !!r.name;
      })
      .map((r) => mapEmailRecipient(r));
  }, [getRecipientsMutation.data, filter]);
  return {
    recipientsOptions: filteredRecipientOptions,
    setFilters,
  };
};
